<template>
    <ac-modal :title="'Switch Default User'" ref="modalRef">
        <template>
            <div class="row alert">
                <span class="col-lg-1 fa fa-2x fa-exclamation-circle"></span>
                <div class="col-lg-11">
                    <p>
                        This action will change the default user from yourself to {{fullName}}
                        and they will receive the bulk of email communications from this point forward.
                    </p>
                    <p style="color: red;">
                        * This action will also be inherited by all the providers beneath this level where you are the default user.
                    </p>
                </div>
            </div>
        </template>
        <template slot="buttons">
            <ac-button type="button" class="btn btn-sm btn-green" :action="switchUser">SWITCH DEFAULT USER</ac-button>
        </template>
    </ac-modal>
</template>

<script>
    import {api} from "../../global/framework/api.js";

    export default {
        name: "DefaultUserModal",
        data() {
            return {
                controller: null,
                entityId: null,
                contactId: null,
                widgetReady: false,
                fullName: "",
            }
        },
        methods: {
            async showModal({contactId, controller, associatedEntityId}) {
                this.$data.contactId = contactId;
                this.$data.controller = controller;
                this.$data.entityId = associatedEntityId;
                //Load contact Info
                let info = await api.get("Shared", contactId, "GetBasicContactInfo");
                this.$data.fullName = info.firstName + " " + info.lastName;
                this.$refs.modalRef.open();
            },
            async switchUser() {
                let self = this;
                let result = await api.post(this.$data.controller, 'UpdateDefaultContact', {entityId: this.$data.entityId, contactId: this.$data.contactId});
                if (result) {
                    self.$refs.modalRef.close();
                    self.$bus.$emit(self.$bus.$AcEvents.CONTACT_CHANGE, self.model);
                }
            }
        }
    }
</script>

<style scoped>

</style>